import { de } from './de/translation.json'
import { en } from './en/translation.json'
import { en_gb } from './en_gb/translation.json'
import { es } from './es/translation.json'
import { es_mx } from './es_mx/translation.json'
import { fr } from './fr/translation.json'
import { ga } from './ga/translation.json'
import { pl } from './pl/translation.json'

const resource = {
  de: de,
  en: en,
  en_gb: en_gb,
  es: es,
  es_mx: es_mx,
  fr: fr,
  ga: ga,
  pl: pl,
}

export default resource
